import { isAxiosError } from "axios";
import { format } from "date-fns";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TagAssignmentService } from "@/services/tagAssignment/tagAssignment.service";
import { showError, showSuccess } from "@/utils/notification";
import { useWorkspaces } from "./useWorkspaces";

export const useExecuteTagAssignment = () => {
  const { t } = useTranslation("admin");
  const [isLoading, setIsLoading] = useState(false);
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  const executeTagAssignment = async (startDate: Date, endDate: Date) => {
    setIsLoading(true);

    const start_date = format(startDate, "yyyy-MM-dd");
    const end_date = format(endDate, "yyyy-MM-dd");

    try {
      await TagAssignmentService.executeTagAssignment(
        sessionCurrentWorkspaceId,
        start_date,
        end_date,
      );
      setIsLoading(false);
      showSuccess(t("tagAssignment.message.executeSuccess"));
    } catch (error) {
      console.error(error);
      setIsLoading(false);

      if (
        isAxiosError(error)
        && error.response?.data?.detail === "ACTIVE_TAG_ASSIGNMENT_WORKFLOW_EXISTS"
      ) {
        showError(t("tagAssignment.message.workflowAlreadyRunning"));
      } else {
        showError(t("tagAssignment.message.executeError"));
      }
    }
  };

  return {
    isLoading,
    executeTagAssignment,
  };
};
